/**
 * Guards on what comes back from speech-to-text.
 *
 * In push-to-talk this barely matters - a junk transcript is visible in the
 * input and the user just does not press enter. Voice mode submits whatever it
 * gets and then listens again, so a transcript of "." or "" becomes an empty
 * question, an empty answer, and another round of the same: a loop that fills
 * the conversation with junk and burns an assistant run each time.
 */

/** Shortest transcript that could plausibly be a question. */
const MIN_TRANSCRIPT_CHARS = 2;

export function isUsableTranscript(text: string): boolean {
  const trimmed = text.trim();
  if (trimmed.length < MIN_TRANSCRIPT_CHARS) return false;
  // Punctuation-only output is what transcription returns for near-silence.
  return /[\p{L}\p{N}]/u.test(trimmed);
}
